import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
const ProviderContext = createContext(null);
export function ReaderProvider({ source, children }) {
    const value = useMemo(() => ({ source }), [source]);
    return _jsx(ProviderContext.Provider, { value: value, children: children });
}
export function useReaderSource() {
    const ctx = useContext(ProviderContext);
    if (!ctx)
        throw new Error('useReaderSource must be used within <ReaderProvider>');
    return ctx.source;
}
//# sourceMappingURL=provider.js.map